import React from "react";
import { initialsOf } from "../../_config/okrPlansCoachFormat";
import PlanCard from "../PlanCard/PlanCard";

// ═══════════════════════════════════════════════════════════════════════════
// One team member — today's member card as an accordion (CD6): header row
// (avatar, name, role · Total Plans · Active Plans · Check-in due) toggles
// the member's plan cards. No plans → a quiet line, no chevron.
// ═══════════════════════════════════════════════════════════════════════════

const MemberRow = ({ member, open, quarterLabel, onToggle, onOpenPlan }) => {
  const plans = member.plans || [];
  const canOpen = plans.length > 0;
  const due =
    member.checkins_due ?? plans.reduce((n, p) => n + (p.checkins_due || 0), 0);
  return (
    <div className="member-card mb-3 d-flex justify-content-center flex-column">
      <div
        className={`d-flex align-items-center justify-content-between member-main opc-member-head${
          canOpen ? " cursor-pointer active-card" : ""
        }${open ? " is-open" : ""}`}
        role={canOpen ? "button" : undefined}
        tabIndex={canOpen ? 0 : undefined}
        aria-expanded={canOpen ? open : undefined}
        onClick={canOpen ? onToggle : undefined}
        onKeyDown={(e) =>
          canOpen &&
          (e.key === "Enter" || e.key === " ") &&
          (e.preventDefault(), onToggle())
        }
      >
        <div className="d-flex align-items-center">
          <div className="avtar-badge d-flex align-items-center justify-content-center">
            <span className="fw-bold dark-grey">
              {member.initials || initialsOf(member.name)}
            </span>
          </div>
          <span className="fw-bold dark-grey ms-3">{member.name}</span>
          {member.role ? (
            <span className="light-text small ms-2">{member.role}</span>
          ) : null}
          {member.is_active === false ? (
            <span className="opc-tag ms-2">Deactivated</span>
          ) : null}
        </div>
        {!canOpen ? (
          <span className="light-text small">
            {member.total_plans === 0
              ? "No individual objective this quarter"
              : `No OKR plan in ${quarterLabel}`}
          </span>
        ) : (
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column me-4">
              <span className="fw-bold light-text detail-text">
                {member.total_plans ?? plans.length}
              </span>
              <span className="small light-text">Total Plans</span>
            </div>
            <div className="d-flex flex-column me-4">
              <span className="fw-bold light-text detail-text">
                {member.active_plans ?? 0}
              </span>
              <span className="small light-text">Active Plans</span>
            </div>
            <div
              className={`checkin-badge ${due ? "success" : "neutral"} d-flex align-items-center px-2 opc-checkin-badge`}
            >
              <span className="fw-bold">{due || "No"}</span>
              <span className="extra-small light-text ms-2">
                {due === 1 ? "Check-in" : "Check-ins"} due
              </span>
            </div>
            <i
              className="fa-solid fa-chevron-down opc-member-chev"
              aria-hidden="true"
            />
          </div>
        )}
      </div>
      {canOpen && open ? (
        <div className="border-top opc-plan-cards">
          <div className="row">
            {plans.map((p) => (
              <PlanCard
                key={p.plan_unique_id}
                plan={p}
                onOpen={() => onOpenPlan(p)}
              />
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default MemberRow;
